<script>
    import { onMount, createEventDispatcher } from 'svelte';
    import mapboxgl from 'maplibre-gl';
	  import MapboxDraw from '@mapbox/mapbox-gl-draw';
    import * as turf from '@turf/turf';
    import { analytics, squareOutline, radioButtonOn, brush, today } from 'ionicons/icons/index.mjs';
    export let modal;
    export let table;
		export let tooltips;
    let selectedFeature = null;
    let accuracyPopup = null;
    let firstLocation = true;
    let loading = true;
    let error = "";
    let renderer = null;
    let isDrawing = false;
    let map = null;
    let drawControl = null;
    let geolocateControl = null;
    let location = {
      status: "",
      enabled: false,
      label: "off"
    };
    let settings = {
      location: "default",
      units: "feet",
      rotation: false,
      newTab: false,
      serial: ""
    }

	const dispatch = createEventDispatcher();
  onMount(async () => {
      loadMap();
  });

  function loadMap() {
    map = new mapboxgl.Map({
      container: "mb-preview",
      minZoom: 0,
      maxZoom: 20,
      style: 'https://api.maptiler.com/maps/streets/style.json?key=02rAug6816zxBfqKVHYR',
      attributionControl: false,
			pitchWithRotate: false
		});
    drawControl = new MapboxDraw({
			displayControlsDefault: false,
			styles: [
				{
					'id': 'gl-draw-polygon-fill-inactive',
					'type': 'fill',
					'filter': ['all',
					['==', 'active', 'false'],
					['==', '$type', 'Polygon'],
					['!=', 'mode', 'static']
					],
					'paint': {
					'fill-color': '#3bb2d0',
					'fill-outline-color': '#3bb2d0',
					'fill-opacity': 0.1
					}
				},
				{
					'id': 'gl-draw-polygon-fill-active',
					'type': 'fill',
					'filter': ['all', ['==', 'active', 'true'], ['==', '$type', 'Polygon']],
					'paint': {
					'fill-color': '#00ab5f',
					'fill-outline-color': '#00ab5f',
					'fill-opacity': 0.1
					}
				},
				{
					'id': 'gl-draw-polygon-midpoint',
					'type': 'circle',
					'filter': ['all',
					['==', '$type', 'Point'],
					['==', 'meta', 'midpoint']],
					'paint': {
					'circle-radius': 3,
					'circle-color': '#00ab5f'
					}
				},
				{
					'id': 'gl-draw-polygon-stroke-inactive',
					'type': 'line',
					'filter': ['all',
					['==', 'active', 'false'],
					['==', '$type', 'Polygon'],
					['!=', 'mode', 'static']
					],
					'layout': {
					'line-cap': 'round',
					'line-join': 'round'
					},
					'paint': {
					'line-color': '#3bb2d0',
					'line-width': 2
					}
				},
				{
					'id': 'gl-draw-polygon-stroke-active',
					'type': 'line',
					'filter': ['all', ['==', 'active', 'true'], ['==', '$type', 'Polygon']],
					'layout': {
					'line-cap': 'round',
					'line-join': 'round'
					},
					'paint': {
					'line-color': '#00ab5f',
					'line-dasharray': [0.2, 2],
					'line-width': 2
					}
				},
				{
					'id': 'gl-draw-line-inactive',
					'type': 'line',
					'filter': ['all',
					['==', 'active', 'false'],
					['==', '$type', 'LineString'],
					['!=', 'mode', 'static']
					],
					'layout': {
					'line-cap': 'round',
					'line-join': 'round'
					},
					'paint': {
					'line-color': '#3bb2d0',
					'line-width': 2
					}
				},
				{
					'id': 'gl-draw-line-active',
					'type': 'line',
					'filter': ['all',
					['==', '$type', 'LineString'],
					['==', 'active', 'true']
					],
					'layout': {
					'line-cap': 'round',
					'line-join': 'round'
					},
					'paint': {
					'line-color': '#00ab5f',
					'line-dasharray': [0.2, 2],
					'line-width': 2
					}
				},
				{
					'id': 'gl-draw-polygon-and-line-vertex-stroke-inactive',
					'type': 'circle',
					'filter': ['all',
					['==', 'meta', 'vertex'],
					['==', '$type', 'Point'],
					['!=', 'mode', 'static']
					],
					'paint': {
					'circle-radius': 5,
					'circle-color': '#fff'
					}
				},
				{
					'id': 'gl-draw-polygon-and-line-vertex-inactive',
					'type': 'circle',
					'filter': ['all',
					['==', 'meta', 'vertex'],
					['==', '$type', 'Point'],
					['!=', 'mode', 'static']
					],
					'paint': {
					'circle-radius': 3,
					'circle-color': '#00ab5f'
					}
				},
				{
					'id': 'gl-draw-point-point-stroke-inactive',
					'type': 'circle',
					'filter': ['all',
					['==', 'active', 'false'],
					['==', '$type', 'Point'],
					['==', 'meta', 'feature'],
					['!=', 'mode', 'static']
					],
					'paint': {
					'circle-radius': 5,
					'circle-opacity': 1,
					'circle-color': '#fff'
					}
				},
				{
					'id': 'gl-draw-point-inactive',
					'type': 'circle',
					'filter': ['all',
					['==', 'active', 'false'],
					['==', '$type', 'Point'],
					['==', 'meta', 'feature'],
					['!=', 'mode', 'static']
					],
					'paint': {
					'circle-radius': 3,
					'circle-color': '#3bb2d0'
					}
				},
				{
					'id': 'gl-draw-point-stroke-active',
					'type': 'circle',
					'filter': ['all',
					['==', '$type', 'Point'],
					['==', 'active', 'true'],
					['!=', 'meta', 'midpoint']
					],
					'paint': {
					'circle-radius': 7,
					'circle-color': '#fff'
					}
				},
				{
					'id': 'gl-draw-point-active',
					'type': 'circle',
					'filter': ['all',
					['==', '$type', 'Point'],
					['!=', 'meta', 'midpoint'],
					['==', 'active', 'true']],
					'paint': {
					'circle-radius': 5,
					'circle-color': '#00ab5f'
					}
				},
				{
					'id': 'gl-draw-polygon-fill-static',
					'type': 'fill',
					'filter': ['all', ['==', 'mode', 'static'], ['==', '$type', 'Polygon']],
					'paint': {
					'fill-color': '#404040',
					'fill-outline-color': '#404040',
					'fill-opacity': 0.1
					}
				},
				{
					'id': 'gl-draw-polygon-stroke-static',
					'type': 'line',
					'filter': ['all', ['==', 'mode', 'static'], ['==', '$type', 'Polygon']],
					'layout': {
					'line-cap': 'round',
					'line-join': 'round'
					},
					'paint': {
					'line-color': '#404040',
					'line-width': 2
					}
				},
				{
					'id': 'gl-draw-line-static',
					'type': 'line',
					'filter': ['all', ['==', 'mode', 'static'], ['==', '$type', 'LineString']],
					'layout': {
					'line-cap': 'round',
					'line-join': 'round'
					},
					'paint': {
					'line-color': '#404040',
					'line-width': 2
					}
				},
				{
					'id': 'gl-draw-point-static',
					'type': 'circle',
					'filter': ['all', ['==', 'mode', 'static'], ['==', '$type', 'Point']],
					'paint': {
					'circle-radius': 5,
					'circle-color': '#404040'
					}
				}
			]
		});
    map.addControl(drawControl);
		map.on('draw.create', updateArea);
		map.on('draw.delete', updateArea);
		map.on('draw.update', updateArea);
		map.on('draw.selectionchange', selectionChange);
    geolocateControl = new mapboxgl.GeolocateControl({
			positionOptions: {
				enableHighAccuracy: true
			},
			showUserLocation: false,
			trackUserLocation: true
		});
		map.addControl(geolocateControl, "top-right");
		geolocateControl.on("geolocate", function (e) {
			updateLocation({
				accuracy: e.coords.accuracy,
				altitude: e.coords.altitude,
				altitudeAccuracy: e.coords.altitudeAccuracy,
				heading: e.coords.heading,
				latitude: e.coords.latitude,
				longitude: e.coords.longitude,
				speed: e.coords.speed,
				timestamp: e.timestamp
			})
		});
		geolocateControl.on("error", function (e) {
			location.status = "busy";
			location.label = "error";
		});
    map.once("styledata", function () {
      map.addSource('geolocation', {
        "type": "geojson",
          "data": {
          "type": "FeatureCollection",
          "features": []
          }
        });
        var framesPerSecond = 15;
        var initialOpacity = 1
        var opacity = initialOpacity;
        var initialRadius = 6;
        var radius = initialRadius;
        var maxRadius = 18;
        map.addLayer({
          "id": "__geolocation",
          "source": "geolocation",
          "type": "circle",
          "paint": {
            "circle-radius": initialRadius,
            "circle-radius-transition": {duration: 0},
            "circle-opacity-transition": {duration: 0},
            "circle-color": "#007cbf"
          }
        });

        map.addLayer({
          "id": "__geolocation1",
          "source": "geolocation",
          "type": "circle",
          "paint": {
            "circle-radius": initialRadius,
            "circle-color": "#007cbf",
            "circle-stroke-width": 2,
            "circle-stroke-color": "#ffffff"
          }
        });

        function animateMarker(timestamp) {
          setTimeout(function(){
            requestAnimationFrame(animateMarker);

            radius += (maxRadius - radius) / framesPerSecond;
            opacity -= ( .9 / framesPerSecond );

            if (opacity <= 0) {
              radius = initialRadius;
              opacity = initialOpacity;
            }

            map.setPaintProperty('__geolocation', 'circle-radius', radius);
            map.setPaintProperty('__geolocation', 'circle-opacity', opacity);

          }, 1000 / framesPerSecond);

        }

        animateMarker(0);
    });
  }

  function updateLocation(locationData) {
		if (!location.enabled)
				return false;
			var accuracy = 100;
			if (locationData.accuracy) {
				var accuracyMeters = Number(locationData.accuracy);
				var accuracyFeet = (accuracyMeters * 3.28084).toFixed(2);
				accuracy = accuracyFeet;
			}
			location = locationData;
			location.accuracy = accuracy;
			location.status = "online";
			location.enabled = true;
			location.label = "active";
			if (location.latitude)
				location.latitude = Number(location.latitude);
			if (location.longitude)
				location.longitude = Number(location.longitude);
			if (location.timestamp)
				location.timestamp = new Date(Number(location.timestamp)).toISOString();
			if (location.latitude && location.longitude) {
				map.getSource("geolocation").setData({
					type: "FeatureCollection",
					features: [{
						type: "Feature",
						properties: location,
						geometry: {
						type: "Point",
						coordinates: [location.longitude, location.latitude]
						}
					}]
				});
				if (accuracyPopup)
					accuracyPopup.remove();
				accuracyPopup = new mapboxgl.Popup({closeOnClick: false, closeButton: false, anchor: 'right', offset: 10})
				.setLngLat([location.longitude, location.latitude])
				.setHTML('<i class="icon icon-location"></i> ' + accuracy + " ft");
				accuracyPopup.addTo(map);
				if (firstLocation) {
					map.flyTo({center: [location.longitude, location.latitude], zoom: 18});
					firstLocation = false;
				}
			}
			setTimeout(function () {
				if (location && location.enabled) {
					location.status = "away";
					location.label = "stale";
				}
			}, 60000);
  }

  function updateArea(e) {
		var data = {
			type: "FeatureCollection",
			features: e.features
		};
		if (data.features.length > 0) {
			var feature = data.features[0];
			var label = "User Feature";
			var idField = "_id";
			var selectedLayer = { id: "__draw", metadata: {} };
			
			if (feature.geometry.type == "Polygon") {
				var area = turf.default.area(data);
				if (settings.units != "meters")
					area = turf.default.convertArea(area, "meters", settings.units);
				// restrict to area to 2 decimal points
				var rounded_area = Math.round(area*100)/100;

				feature.properties = {};
				feature.properties._id = "user";
				feature.properties.area = label;
			}
			else if (feature.geometry.type == "LineString") {
				var length = turf.default.length(data, {units: settings.units});
				// restrict to area to 2 decimal points
				var rounded_length = Math.round(length*100)/100;

				feature.properties = {};
				feature.properties._id = "user";
				feature.properties.distance = label;
			}
			else if (feature.geometry.type == "Point") {
				feature.properties = {};
				feature.properties._id = "user";
			}

      selectedFeature = feature;
      isDrawing = false;
			map.getCanvas().style.cursor = "";
		}
	}
	function selectionChange (e) {
		var data = {
			type: "FeatureCollection",
			features: e.features
		};
		if (data.features.length > 0) {
			var feature = data.features[0];
			var label = "User Feature";
			var idField = "_id";
			var selectedLayer = { id: "__draw", metadata: {}};

			if (feature.geometry.type == "Polygon") {
				var area = turf.default.area(data);
				if (settings.units != "meters")
					area = turf.default.convertArea(area, "meters", settings.units);
				// restrict to area to 2 decimal points
				var rounded_area = Math.round(area*100)/100;

				feature.properties = {};
				feature.properties._id = "user";
				feature.properties.area = label;
			}
			else if (feature.geometry.type == "LineString") {
				var length = turf.default.length(data, {units: settings.units});
				// restrict to area to 2 decimal points
				var rounded_length = Math.round(length*100)/100;

				feature.properties = {};
				feature.properties._id = "user";
				feature.properties.distance = label;
			}
			else if (feature.geometry.type == "Point") {
				feature.properties = {};
				feature.properties._id = "user";
			}

      selectedFeature = feature;
      isDrawing = false;
			map.getCanvas().style.cursor = "";
		}
	}

  function drawHandler(e, mode) {
		e.currentTarget.blur();
		if (isDrawing) {
			map.getCanvas().style.cursor = "";
			var features = drawControl.getAll().features;
      selectedFeature = features[0];
			var featureId = selectedFeature.id;
			drawControl.changeMode("simple_select", { featureIds: [featureId] });
			isDrawing = false;
		}
		else {
      drawControl.deleteAll();
      selectedFeature = null;
			drawControl.changeMode("simple_select", { featureIds: [] });
			map.getCanvas().style.cursor = "crosshair";
			drawControl.changeMode(mode);
			isDrawing = true;
		}
	}

  function focusHandler(event) {
    setTimeout(function () {
        event.target.nextSibling.nextSibling.style.display = "";
    }, 500);
	}

  function toggleDropdown(event) {
    if (event.currentTarget.nextSibling.nextSibling.style.display == "") {
      event.currentTarget.nextSibling.nextSibling.style.display = "block";
    }
    else {
      event.currentTarget.nextSibling.nextSibling.style.display = "";
      event.currentTarget.blur();
    }
  }

  function locationHandler(e) {
		e.currentTarget.blur();
		if (window.platform == "Android") {
			androidAdapter.checkGeolocationPermission();
		}
		if (location.enabled) {
			map.removeControl(geolocateControl);
			map.addControl(geolocateControl, "top-right");
			if (settings.location == "ws")
				return;
			if (settings.location == "gnss") {
				if (window.platform == "Android") {
					androidAdapter.disconnect();
				}
				else if (window.platform == "iOS") {
					try {
            webkit.messageHandlers.callbackHandler.postMessage("geolocation_off");
					} catch(err) {
						createToast({
              message: "Geolocation error."
            });
					}
				}
			}
			else {
				if (window.platform == "Android") {
					androidAdapter.stopLocation();
				}
			}
			location.enabled = false;
			firstLocation = true;
			location.status = "";
			location.label = "off";
			accuracyPopup.remove();
			accuracyPopup = null;
			map.getSource("geolocation").setData({
				type: "FeatureCollection",
				features: []
			});
		}
		else {
			location.enabled = true;
			location.status = "away";
			location.label = "stale";
			if (location.latitude && location.longitude) {
				map.getSource("geolocation").setData({
					type: "FeatureCollection",
					features: [{
						type: "Feature",
						properties: location,
						geometry: {
						type: "Point",
						coordinates: [location.longitude, location.latitude]
						}
					}]
				});
				if (accuracyPopup)
					accuracyPopup.remove();
				accuracyPopup = new mapboxgl.Popup({closeOnClick: false, closeButton: false, anchor: 'right', offset: 10})
				.setLngLat([location.longitude, location.latitude])
				.setHTML('<i class="icon icon-location"></i> ' + location.accuracy + " ft");
				accuracyPopup.addTo(map);
			}
			if (settings.location == "ws")
				return;
			if (settings.location == "gnss") {
				if (window.platform == "Android") {
					var result = androidAdapter.connect(settings.device.match(/.{1,2}/g).join("-"));
					createToast({
						message: result
					});
				}
				else if (window.platform == "iOS") {
					try {
            webkit.messageHandlers.serialHandler.postMessage(settings.serial);
            webkit.messageHandlers.callbackHandler.postMessage("geolocation_on");
					} catch(err) {
            createToast({
              message: "Geolocation error."
            });
					}
				}
			}
			else {
				if (window.platform == "Android") {
					androidAdapter.getLocation();
				}
				else {
					geolocateControl.trigger();
				}
			}
		}
	}

  function reportHandler(e) {
    console.log(selectedFeature);
    var feature = null;
    if (selectedFeature) {
      feature = selectedFeature
    }
    else if (location.enabled) {
      feature = {
        type: "Feature",
        properties: {},
        geometry: {
					type: "Point",
					coordinates: [location.longitude, location.latitude]
				}
      }
    }
    else {
      dispatch('message', {
        type: "toast",
        data: {
          message: "No feature selected."
        }
      });
      return;
    }
    e.currentTarget.blur();
    dispatch('message', {
        type: "modal",
        data: {
          view: "form",
          location: {
            status: "",
            enabled: false,
            label: "off"
          },
          mapId: table.id,
          mapName: table.name,
          form: modal.form,
          layer: null,
          map: null,
          feature: feature
        }
		});
  }

	function close() {
		dispatch('message', {
        type: "modal",
        modal: null
		});
  }
</script>

<div class="modal modal-lg active">
    <div class="modal-overlay" on:click={close} aria-label="Close"></div>
    <div id="modal-container" class="modal-container">
        <div class="modal-header">
            <div class="tile tile-centered">
                <div class="tile-content">
                    <div class="tile-title">Map</div>
                </div>
                <div class="tile-action">
                    {#if !isDrawing}
                      <div class="dropdown dropdown-left">
                        <button class="btn btn-link dropdown-toggle" on:focusout={focusHandler} on:click={toggleDropdown}>
                          <i class="svg svg-light">{@html brush.md}</i>
                        </button>
                        <div class="dropdown-container three-buttons">
                          <div class="btn-group btn-group-block">
                            <button class="btn btn-link {tooltips ? "tooltip tooltip-left" : ""}" data-tooltip="Draw Polygon" on:click|stopPropagation={(e) => {
                              //closeDropdown(e);
                              drawHandler(e, "draw_polygon");
                            }}><i class="svg">{@html squareOutline.md}</i></button>
                            <button class="btn btn-link {tooltips ? "tooltip tooltip-left" : ""}" data-tooltip="Draw Polyline" on:click|stopPropagation={(e) => {
                              //closeDropdown(e);
                              drawHandler(e, "draw_line_string");
                            }}><i class="svg">{@html analytics.md}</i></button>
                            <button class="btn btn-link {tooltips ? "tooltip tooltip-left" : ""}" data-tooltip="Draw Point" on:click|stopPropagation={(e) => {
                              //closeDropdown(e);
                              drawHandler(e, "draw_point");
                            }}><i class="svg">{@html radioButtonOn.md}</i></button>
                          </div> 
                        </div>
                      </div>
                    {/if}
                    {#if isDrawing}
                      <button class="btn btn-link {tooltips ? "tooltip tooltip-left" : ""} active" data-tooltip="End Draw" on:click={drawHandler}><i class="svg svg-light">{@html brush.md}</i></button>
                    {/if}
                    {#if !isDrawing}
                      <figure class="status avatar avatar-md {tooltips ? "tooltip tooltip-left" : ""} {location.enabled ? "active" : ""}"
                        data-tooltip="Location: {location.label}" on:click={locationHandler}>
                        <i class="icon icon-location"></i>
                        <i class="avatar-presence {location.status}"></i>
                      </figure>
                    {/if}
                    <button class="btn btn-link dropdown-toggle {tooltips ? "tooltip tooltip-left" : ""}" data-tooltip="Form" on:click={reportHandler}>
                      <i class="svg svg-light">{@html today.md}</i>
                    </button>
                    <button class="btn btn-link {tooltips ? "tooltip tooltip-left" : ""}" data-tooltip="Close" on:click={close} aria-label="Close"><i class="icon icon-cross mt-1"></i></button>
                </div>
            </div>
        </div>
        <div class="modal-body">
          <div id="mb-preview" />
        </div>
    </div>
</div>

<style>
    #mb-preview {
        width: 100%;
        height: 100%;
    }
    .status {
      text-align: center;
      padding: .2rem 0;
      margin: 0 0.4rem;
      cursor: pointer;
      color: #00ab5f;
      background-color: #efefef;
      border: 1px solid #00ab5f;
    }
    .status.active {
      background-color: #ccc;
    }
    .dropdown-container.three-buttons {
      background-color: #efefef;
			width: 6.3rem;
			left: -7rem;
			z-index: 2;
    }
    .no-hover {
        pointer-events: none;
    }
    .modal.modal-lg .modal-overlay {
        background: rgba(247, 248, 249, 0.75);
    }
    .modal.modal-lg .modal-container {
        height: 100vh;
        height: calc(var(--vh, 1vh) * 100);
        padding: 0;
    }
    .modal.modal-lg .modal-header {
        background-color: #00ab5f;
        color: #fff;
        padding: 0.2rem 0.4rem;
    }
    .modal.modal-lg .modal-header .btn.btn-link {
        color: white;
    }
    .modal.modal-lg .modal-body {
        padding: 0;
        height: calc(100vh - 2.1rem);
    }
    ::-webkit-scrollbar {
      width: 6px;
      background-color: #f7f8f9;
    }
	  ::-webkit-scrollbar-thumb {
		  background-color: rgba(122,129,132, 1);
    }
</style>